import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiResponse } from '../../models/common.model';
import { loadBizProducts, loadBizProductsFailure, loadBizProductsSuccess } from './biz-product.action';
import { CustomerService } from '../../services/customer.service';

@Injectable()
export class BizProductEffects {
  constructor(private actions$: Actions, private customerService: CustomerService) { }

  // Effect to load filtered products
  loadBizProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBizProducts),
      switchMap((action: { categoryId?: any, subCategoryId: any, specialCategory: any, search: any, page: any, limit: any }) =>
        this.customerService.getBizProductList({ categoryId: action.categoryId, subCategoryId: action.subCategoryId, specialCategory: action.specialCategory, search: action.search, page: action.page, limit: action.limit }
        ).pipe(
          map((response: ApiResponse) => {
            return loadBizProductsSuccess({ bizProducts: response.body });
          }),
          catchError((error) =>
            of(
              loadBizProductsFailure({
                error: {
                  message: error.message || 'An unknown error occurred',
                  statusCode: error.status || 500,
                },
              })
            )
          )
        )

      )
    )
  );
}
